<div *ngIf="loading"
     class="container-loading-content is-flex is-justify-content-center is-align-items-center">
    <div class="loading"></div>
</div>
<div *ngIf="!loading && !content" class=" container is-min-height is-fullhd">
    <div>
        <h1 class="title mt-4">404.</h1>
        <h2 class="subtitle">Seite nicht gefunden.</h2>
        <p>Die aufgerufene Seite haben wir leider nicht gefunden.</p>
        <a routerLink="/">Zurück zur Startseite</a>
    </div>
</div>
<div *ngIf="!loading && content" class="dynamic-page container is-min-height is-fullhd">
    <div [injectHTML]="content" (click)="processLinks($event)"></div>
</div>

